import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { HomePage } from '../pages/HomePage';

const ROLE_HOME: Record<string, string> = {
  SUPER_ADMIN: '/super-admin/dashboard',
  COMPANY_ADMIN: '/company-admin/dashboard',
  DISPATCH_AGENT: '/dispatch/dashboard',
  RECOVERY_OFFICER: '/recovery/dashboard',
  COMPANY_AGENT: '/agent/dashboard',
  INDEPENDENT_USER: '/user/dashboard',
  TRANSPORTER: '/transporter/dashboard',
};

export const RoleRouter: React.FC = () => {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="loading-spinner">Loading...</div>;
  if (!user) return <HomePage />;
  return <Navigate to={ROLE_HOME[user.role] ?? '/unauthorized'} replace />;
};
